(function () {
'use strict';
function initialize(root) {
 if(root.dataset.ddqcReady==='1')return;
 root.dataset.ddqcReady='1';
 var cfg=JSON.parse(root.querySelector('.ddqc-settings').textContent);
 cfg.rounding=Number(cfg.rounding)||1;
 cfg.gap=Number(cfg.gap)||0;
 var garments=[{id:1,name:'Crewneck sweatshirt',qty:10,cost:cfg.defaultBlank}];
 var designs=[{id:2,name:'Front',w:11,h:8,all:true,qty:10}];
 var nextId=3, valid=false, estimateText='', currency=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
 function output(key){return root.querySelector('[data-out="'+key+'"]')}
 function number(value){var v=Number(value);return Number.isFinite(v)?v:NaN}
 function money(value){return currency.format(value)}
 function escapeHTML(value){return String(value).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
 function totalUnits(){return garments.reduce(function(sum,g){return sum+Math.max(0,Math.floor(Number(g.qty)||0))},0)}
 function field(key,label,val,type){return '<label class="ddqc-field"><span>'+label+'</span><input data-key="'+key+'" type="'+type+'" '+(type==='number'?'min="0" step="any" ':'')+'value="'+escapeHTML(val)+'"></label>'}
 function rowRender(){
  output('garments').innerHTML=garments.map(function(g,i){
   return '<div class="ddqc-entry" data-kind="garment" data-id="'+g.id+'"><div class="ddqc-entry-head"><strong>Garment group '+(i+1)+'</strong>'+(garments.length>1?'<button type="button" class="ddqc-remove">Remove</button>':'')+'</div><div class="ddqc-fields ddqc-fields-g">'+field('name','Garment / size',g.name,'text')+field('qty','Quantity',g.qty,'number')+field('cost','Estimated blank ($/unit)',g.cost,'number')+'</div></div>'
  }).join('');
  output('designs').innerHTML=designs.map(function(p,i){
   return '<div class="ddqc-entry" data-kind="design" data-id="'+p.id+'"><div class="ddqc-entry-head"><strong>Design '+(i+1)+'</strong>'+(designs.length>1?'<button type="button" class="ddqc-remove">Remove</button>':'')+'</div><div class="ddqc-fields">'+field('name','Placement',p.name,'text')+field('w','Width (inches)',p.w,'number')+field('h','Height (inches)',p.h,'number')+'</div><label class="ddqc-check"><input type="checkbox" data-key="all" '+(p.all?'checked':'')+'> One print on every garment (<span data-all-count>'+totalUnits()+'</span> transfers)</label>'+(p.all?'':'<div class="ddqc-specific">'+field('qty','Specific number of prints',p.qty,'number')+'</div>')+'</div>'
  }).join('');
 }
 function overlapping(a,b){return a.x<b.x+b.w-1e-7&&a.x+a.w>b.x+1e-7&&a.y<b.y+b.h-1e-7&&a.y+a.h>b.y+1e-7}
 function contained(a,b){return a.x>=b.x-1e-7&&a.y>=b.y-1e-7&&a.x+a.w<=b.x+b.w+1e-7&&a.y+a.h<=b.y+b.h+1e-7}
 // Rectangle packing onto a single roll of variable length. This prices material,
 // but it is not a production-ready gang sheet or a promise of printer availability.
 function pack(items,width,length,gap){
  var free=[{x:0,y:0,w:width,h:length}];
  for(var i=0;i<items.length;i++){
   var item=items[i],pick=null;
   for(var j=0;j<free.length;j++){
    var f=free[j];
    for(var rotated=0;rotated<2;rotated++){
     var w=rotated?item.h:item.w,h=rotated?item.w:item.h;
     if(w>width+1e-7||h>length+1e-7)continue;
     var aw=Math.min(width,w+gap),ah=Math.min(length,h+gap);
     if(aw>f.w+1e-7||ah>f.h+1e-7)continue;
     var score=(f.w-aw)*(f.h-ah)+f.y*.001;
     if(!pick||score<pick.score)pick={x:f.x,y:f.y,w:aw,h:ah,score:score};
    }
   }
   if(!pick)return false;
   var fragments=[];
   for(var k=0;k<free.length;k++){
    var r=free[k];
    if(!overlapping(r,pick)){fragments.push(r);continue}
    if(pick.x>r.x+1e-7)fragments.push({x:r.x,y:r.y,w:pick.x-r.x,h:r.h});
    if(pick.x+pick.w<r.x+r.w-1e-7)fragments.push({x:pick.x+pick.w,y:r.y,w:r.x+r.w-pick.x-pick.w,h:r.h});
    if(pick.y>r.y+1e-7)fragments.push({x:r.x,y:r.y,w:r.w,h:pick.y-r.y});
    if(pick.y+pick.h<r.y+r.h-1e-7)fragments.push({x:r.x,y:pick.y+pick.h,w:r.w,h:r.y+r.h-pick.y-pick.h});
   }
   free=fragments.filter(function(a,ai){
    return a.w>1e-7&&a.h>1e-7&&!fragments.some(function(b,bi){
     return ai!==bi&&contained(a,b)&&(b.w*b.h>a.w*a.h+1e-7||(bi<ai&&Math.abs(b.w*b.h-a.w*a.h)<1e-7));
    });
   });
  }
  return true;
 }
 function sheetIncrements(items){
  if(!items.length)return 0;
  var width=number(cfg.sheetWidth),len=number(cfg.sheetLength),area=0,minHeight=0,stackHeight=0;
  items.forEach(function(item){
   area+=item.w*item.h;
   var smallest=Math.min(item.w<=width?item.h:Infinity,item.h<=width?item.w:Infinity);
   minHeight=Math.max(minHeight,smallest);
   stackHeight+=smallest+cfg.gap;
  });
  var lower=Math.max(1,Math.ceil(area/(width*len)),Math.ceil(minHeight/len));
  var upper=Math.max(lower,Math.ceil(stackHeight/len)+1);
  var sorted=items.slice().sort(function(a,b){return b.w*b.h-a.w*a.h||Math.max(b.w,b.h)-Math.max(a.w,a.h)});
  for(var n=lower;n<=upper;n++){
   if(pack(sorted,width,n*len,cfg.gap))return n;
  }
  return upper;
 }
 function compute(){
  var units=totalUnits(),errors=[],blankCost=0,prints=[],transferCount=0,oversized=false;
  if(units<1||units>300)errors.push('Enter a total between 1 and 300 garments.');
  garments.forEach(function(g){
   var q=number(g.qty),c=number(g.cost);
   if(!Number.isInteger(q)||q<1||!Number.isFinite(c)||c<0)errors.push('Garment quantities must be positive whole numbers and estimated garment costs cannot be negative.');
   else blankCost+=q*c;
  });
  designs.forEach(function(p,i){
   var w=number(p.w),h=number(p.h),count=p.all?units:number(p.qty);
   if(!Number.isFinite(w)||!Number.isFinite(h)||w<=0||h<=0){errors.push('Design '+(i+1)+' needs positive width and height.');return}
   if(!Number.isInteger(count)||count<1||count>300){errors.push('Design '+(i+1)+' needs a valid print quantity.');return}
   if(Math.min(w,h)>cfg.sheetWidth+1e-7){errors.push('Design '+(i+1)+' cannot fit the available print width, even when rotated. Contact us for a custom method.');return}
   if(!((w<=cfg.sheetWidth&&h<=cfg.maxLength)||(h<=cfg.sheetWidth&&w<=cfg.maxLength))){errors.push('Design '+(i+1)+' exceeds the maximum continuous printing length. Contact us for a custom quote.');return}
   if(Math.max(w,h)>cfg.sheetLength)oversized=true;
   transferCount+=count;
   if(transferCount<=300)for(var j=0;j<count;j++)prints.push({w:w,h:h});
  });
  if(transferCount>300)errors.push('Orders with more than 300 individual prints require a custom quote.');
  var total=0;
  if(!errors.length){
   var incrementCount=sheetIncrements(prints);
   var productionCost=blankCost+incrementCount*number(cfg.sheetPrice)+(transferCount*number(cfg.laborMinutes)/60)*number(cfg.laborRate)+number(cfg.freight)+number(cfg.setup)+number(cfg.sundries);
   total=Math.ceil((productionCost/(1-number(cfg.margin)/100)-1e-7)/cfg.rounding)*cfg.rounding;
   if(!Number.isFinite(total)||total<0)errors.push('Pricing settings need review.');
  }
  output('qty').textContent=units.toLocaleString('en-US');
  output('placements').textContent=String(designs.length);
  output('transfers').textContent=transferCount.toLocaleString('en-US');
  output('price').textContent=errors.length?'—':money(total);
  output('per').textContent=errors.length?'Review the project details.':money(total/units)+' average per garment';
  var warning=errors.join(' ');
  if(!warning&&oversized)warning='A design larger than one standard pricing increment requires a continuous oversized transfer. We will confirm printing availability and cost before accepting the order.';
  output('warnings').hidden=!warning;output('warnings').textContent=warning;
  valid=errors.length===0;
  root.querySelector('[data-action="copy"]').disabled=!valid;
  estimateText='DAY DREAMS — MERCHANDISE ESTIMATE\nGarments: '+units+'\n'+garments.map(function(g){return g.name+': '+g.qty+' pieces'}).join('\n')+'\nPlacements:\n'+designs.map(function(p){return p.name+': '+p.w+' × '+p.h+' inches, '+(p.all?units:p.qty)+' prints'}).join('\n')+'\nEstimated project total: '+money(total)+'\nAverage price per garment: '+money(total/Math.max(units,1))+'\nPreliminary estimate before sales tax and delivery. Subject to review and approval.';
  var address=root.dataset.contact||'';
  output('inquire').href='mailto:'+encodeURIComponent(address)+'?subject='+encodeURIComponent('Day Dreams merchandise estimate')+'&body='+encodeURIComponent(valid?estimateText:'I would like to discuss a merchandise project.');
  root.querySelectorAll('[data-all-count]').forEach(function(e){e.textContent=String(units)});
 }
 function saveField(target){
  var card=target.closest('[data-kind]');if(!card)return;
  var arr=card.dataset.kind==='garment'?garments:designs,id=Number(card.dataset.id),obj=arr.find(function(item){return item.id===id});
  if(!obj||!target.dataset.key)return;
  obj[target.dataset.key]=target.type==='checkbox'?target.checked:target.value;
  if(target.type==='checkbox')rowRender();
  compute();
 }
 root.addEventListener('input',function(e){if(e.target.type!=='checkbox')saveField(e.target)});
 root.addEventListener('change',function(e){if(e.target.type==='checkbox')saveField(e.target)});
 root.addEventListener('click',function(e){
  var btn=e.target.closest('.ddqc-remove');if(!btn)return;
  var card=btn.closest('[data-kind]'),arr=card.dataset.kind==='garment'?garments:designs,id=Number(card.dataset.id);
  var index=arr.findIndex(function(o){return o.id===id});
  if(index!==-1&&arr.length>1){arr.splice(index,1);rowRender();compute()}
 });
 root.querySelector('[data-action="add-garment"]').addEventListener('click',function(){
  garments.push({id:nextId++,name:'Additional garment / size',qty:1,cost:cfg.defaultBlank});
  rowRender();compute();
 });
 root.querySelector('[data-action="add-design"]').addEventListener('click',function(){
  designs.push({id:nextId++,name:'Additional placement',w:4,h:4,all:true,qty:totalUnits()});
  rowRender();compute();
 });
 root.querySelector('[data-action="copy"]').addEventListener('click',function(){
  if(!valid)return;var button=this;
  if(navigator.clipboard&&navigator.clipboard.writeText){
   navigator.clipboard.writeText(estimateText).then(function(){
    button.textContent='Copied to clipboard';setTimeout(function(){button.textContent='Copy estimate'},1600)
   }).catch(function(){window.prompt('Copy your estimate:',estimateText)});
  }else window.prompt('Copy your estimate:',estimateText);
 });
 rowRender();compute();
}
document.querySelectorAll('[data-ddqc]').forEach(initialize);
document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-ddqc]').forEach(initialize)});
})();